import * as actionTypes from "./supportdeskTypes";

const INITIAL_STATE = {
    customersList: [],
    SAPCustomerList: [],
    contactPersonsList: [],
    ticketsList: [],
    allTicketsList: [],
    ticketRequestorList: [],
    ticketFollowersCCList: [],
    ticketCustomerList: [],
    ticketAssigneeList: [],
    ticketDetails: [],
    serviceCallDetails: [],
    ticketFormSettingsList: [],
    usersTicketFormSettingsList: [],
    customerFormSettingsList: [],
    tabDetailsTicketsList: [],
    ticketRequesterDetail: [],
    insightTicketCount: [],
    macroDropdownList: [],
    usersCustomerFormSettingsList: [],
    ticketHistoryList: [],
    ticketAttachments: [],
    ticketViewCountList: [],
    ticketCustomizedViewCountList: [],
    equipmentList: [],
    problemList: [],
    subProblemList: [],
    logWorkList: [],
    editorLogWorkData: [],
    countryList: [],
    logWorkTicketList: [],
    unknownRequesterList: [],
    customerHeaderFilterValues: {},
    ticketHeaderFilterValues: {},
    tabDetailsTicketId: null,
    searchTicketId: null,
    searchCustomer: null,
    followupData: null,
    clearChats: false,
};

const supportdeskReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        //Customers
        case actionTypes.SETCUSTOMERSLIST:
            return {
                ...state,
                customersList: action.payload.list,
            };
        case actionTypes.SETSAPCUSTOMERSLIST:
            return {
                ...state,
                SAPCustomerList: action.payload.list,
            };
        case actionTypes.SETCONTACTPERSONSLIST:
            return {
                ...state,
                contactPersonsList: action.payload.list,
            };
        case actionTypes.SETCUSTOMERFORMSETTINGSLIST:
            return {
                ...state,
                customerFormSettingsList: action.payload.list,
            };
        case actionTypes.SETUSERSCUSTOMERFORMSETTINGSLIST:
            return {
                ...state,
                usersCustomerFormSettingsList: action.payload.list,
            };
        case actionTypes.SETUNKNOWNREQUESTERLIST:
            return {
                ...state,
                unknownRequesterList: action.payload.list,
            };
        case actionTypes.SET_CUSTOMER_HEADER_FILTER_VALUES:
            return {
                ...state,
                customerHeaderFilterValues: { ...action.payload },
            };
        //Tickets
        case actionTypes.SETTICKETSLIST:
            return {
                ...state,
                ticketsList: action.payload.list,
            };
        case actionTypes.SETALLTICKETLIST:
            return {
                ...state,
                allTicketsList: action.payload.list,
            };
        case actionTypes.SETTABDETAILSTICKETSLIST:
            return {
                ...state,
                tabDetailsTicketsList: action.payload.list,
            };
        case actionTypes.SETTICKETHISTORYLIST:
            return {
                ...state,
                ticketHistoryList: action.payload.list,
            };
        case actionTypes.SETTABDETAILSTICKETID:
            return {
                ...state,
                tabDetailsTicketId: action.payload,
            };
        case actionTypes.SETINSIGHTTICKETCOUNT:
            return {
                ...state,
                insightTicketCount: action.payload.list,
            };
        case actionTypes.SETSEARCHTICKETID:
            return {
                ...state,
                searchTicketId: action.payload,
            };
        case actionTypes.SETSEARCHSCUSTOMER:
            return {
                ...state,
                searchCustomer: action.payload,
            };
        case actionTypes.SETTICKETFORMSETTINGSLIST:
            return {
                ...state,
                ticketFormSettingsList: action.payload.list,
            };
        case actionTypes.SETUSERSTICKETFORMSETTINGSLIST:
            return {
                ...state,
                usersTicketFormSettingsList: action.payload.list,
            };
        case actionTypes.SETTICKETATTACHMENT:
            return {
                ...state,
                ticketAttachments: action.payload.list,
            };
        case actionTypes.SETREQUESTORLIST:
            return {
                ...state,
                ticketRequestorList: action.payload.list,
            };
        case actionTypes.SETFOLLOWERSCCLIST:
            return {
                ...state,
                ticketFollowersCCList: action.payload.list,
            };
        case actionTypes.SETTICKETVIEWCOUNTLIST:
            return {
                ...state,
                ticketViewCountList: action.payload.list,
            };
        case actionTypes.SETTICKETCUSTOMIZEDVIEWCOUNTLIST:
            return {
                ...state,
                ticketCustomizedViewCountList: action.payload.list,
            };
        case actionTypes.SETTICKETCUSTOMERLIST:
            return {
                ...state,
                ticketCustomerList: action.payload.list,
            };
        case actionTypes.SETTICKETREQUESTERDETAIL:
            return {
                ...state,
                ticketRequesterDetail: action.payload.list,
            };
        case actionTypes.SETASSIGNEELIST:
            return {
                ...state,
                ticketAssigneeList: action.payload.list,
            };
        case actionTypes.SETMACRODROPDOWNLIST:
            return {
                ...state,
                macroDropdownList: action.payload.list,
            };
        case actionTypes.SETTICKETDETAILS:
            return {
                ...state,
                ticketDetails: action.payload.list,
            };
        case actionTypes.SETSERVICECALLDETAIL:
            return {
                ...state,
                serviceCallDetails: action.payload.list,
            };
        case actionTypes.SET_EQUIPMENT_LIST:
            return {
                ...state,
                equipmentList: action.payload.list,
            };
        case actionTypes.SET_PROBLEM_LIST:
            return {
                ...state,
                problemList: action.payload.list,
            };
        case actionTypes.SET_SUB_PROBLEM_LIST:
            return {
                ...state,
                subProblemList: action.payload.list,
            };
        case actionTypes.SET_TICKET_HEADER_FILTER_VALUES:
            return {
                ...state,
                ticketHeaderFilterValues: { ...action.payload },
            };
        case actionTypes.SETCLEARCHATS:
            return {
                ...state,
                clearChats: action.payload.chat,
            };
        case actionTypes.SETFOLLOWUPDATA:
            return {
                ...state,
                followupData: action.payload,
            };
        //Logwork
        case actionTypes.SETLOGWORKLIST:
            return {
                ...state,
                logWorkList: action.payload.list,
            };
        case actionTypes.SETLOGWORKTICKETLIST:
            return {
                ...state,
                logWorkTicketList: action.payload.list,
            };
        case actionTypes.SETEDITORLOGWORKDATA:
            return {
                ...state,
                editorLogWorkData: action.payload.list
            };
        case actionTypes.SETCOUNTRYLIST:
            return {
                ...state,
                countryList: action.payload.list
            };
        case actionTypes.CLEARLOGWORKTICKETLIST:
            return {
                ...state,
                logWorkTicketList: null,
            };
        default:
            return state;
    };
};

export default supportdeskReducer;